import { sendData, getData } from './../../misc/server.js';
export default {
    state: {

        data: [],
        loading: false,

    },
    mutations:
    {

        SET_LECTURE(state, payload) {
            state.data = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        },


    },
    actions: {


        async get_lecture({ commit }, payload) {
            var url = "lecture/get?";

            if (payload.id) {
                url += "id=" + payload.id;
            }
            url += "&";
            
            commit('SET_LOADING', true);
            var response = await getData(url);

            commit("SET_LECTURE", response);
            commit('SET_LOADING', false);

        },



    },
    getters: {


        lectures(state) {
            return state.data;
        },
        lecture_loading(state) {
            return state.loading;
        },
        each_lecture(state) {
            if (state.data) {
                return state.data[0];
            }
        },

    }
}